/**************************************************
 * Nombre:       Seccion_Config_Habitaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {AddAPhotoOutlined, ListOutlined, SettingsOutlined} from '@mui/icons-material'
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_DINERO,
    CASILLA_ESTADO,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {ESTADOSHABITACIONES, ESTADOSRESERVAS} from "../../Modulo_Motor_Reservas/Constantes";
import Dialogo_Habitaciones from "../Dialogos/Habitaciones/Dialogo_Habitaciones";
import Tarjeta_Titulo_Subtitulo_Grafica_Larga
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Larga";
import Barras_Horizontales_Nombre from "../../Modulo_Graficas/Graficas/Barras_Horizontales_Nombre";
import React, {useEffect, useState} from "react";
import {arrConteoColPropiedadEstados} from "../../Servicios/BD/Contadores_Arr/arrConteoColPropiedadEstados";
import {where} from "firebase/firestore";
import {obtenerHabitaciones} from "../../Modulo_Motor_Reservas/Controladores/obtenerHabitaciones";
import Dialogo_Habitaciones_Detalles from "../Dialogos/Habitaciones/Dialogo_Habitaciones_Detalles";
import Dialogo_Habitaciones_Fotos from "../Dialogos/Habitaciones/Dialogo_Habitaciones_Fotos";

const Seccion_Config_Habitaciones = () => {
    const [usoHabitaciones, setUsoHabitaciones] = useState([])
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025({coleccion: 'habitaciones'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Habitaciones,
        titulo: 'Detalles de habitacion',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoDetalles, abrir: abrirDetalles} = useDialogo({
        Componente: Dialogo_Habitaciones_Detalles,
        titulo: 'Detalles de habitacion',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoFotos, abrir: abrirFotos} = useDialogo({
        Componente: Dialogo_Habitaciones_Fotos,
        titulo: 'Fotos de habitacion',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'configuracion':
                abrir(data)
                break
            case 'fotos':
                abrirFotos(data)
                break
            case 'detalles':
                abrirDetalles(data)
                break
            default :
                abrir(data)

        }
    }

    const obtenerDatos = async () => {

        let arrHabitaciones = await obtenerHabitaciones()

        let w = [where('estado', '!=', ESTADOSRESERVAS[5])]
        let origenes_ = await arrConteoColPropiedadEstados({
            coleccion: 'reservas',
            propiedad: 'numero',
            arrEstados: arrHabitaciones.map((it) => it.numero),
            wheres: w
        })
        setUsoHabitaciones(origenes_)

    }


    useEffect(() => {
        obtenerDatos()
    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px'}}
                spacing={3}
            >


                <Dialogo/>

                <DialogoDetalles/>

                <DialogoFotos/>

                <Grid container size={12}
                      sx={{height: 180}}
                >
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Uso de habitaciones'}
                        subtitulo={'segun reservas'}
                        Grafica={Barras_Horizontales_Nombre}
                        marginTop={8}
                        height={130}
                        series={
                            [{
                                name: 'Reservas',
                                data: usoHabitaciones.map((e) => e.cantidad)
                            }]
                        }

                        labels={usoHabitaciones.map((e) => e.nombre)}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Configuracion Habitaciones'}
                        descripcion={`${numeroFilas} habitaciones en base de datos`}
                        filtros={filtros}
                        numeroFilas={numeroFilas}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Config_Habitaciones

const filtros = [
    {
        nombre: 'Numero',
        direccion: 'asc',
        propiedad: 'numero'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]


const datosCabecera = [
    {
        nombre: 'Numero',
        direccion: 'left',
        propiedad: 'numero',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Sector',
        direccion: 'left',
        propiedad: 'torre',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Divicion',
        direccion: 'left',
        propiedad: 'piso',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Tipo',
        direccion: 'left',
        propiedad: 'tipo',
        tipo: CASILLA_TEXTO
    },

    {
        nombre: 'Valor Hab',
        direccion: 'right',
        propiedad: 'tarifa',
        tipo: CASILLA_DINERO
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSHABITACIONES
    },


]

const botonesData = [
    {
        nombre: 'Configuracion',
        id: 'configuracion',
        icono: SettingsOutlined
    },
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ListOutlined
    },
    {
        nombre: 'Fotos',
        id: 'fotos',
        icono: AddAPhotoOutlined
    },

]


